<template>
  <div v-show="show" id="custom-alert" class="dialog-alert" style="display: block;">
    <p>{{msg}}</p>
  </div>
</template>

<script>
    export default {
        name: "alert",
        props: {
            show: Boolean,
            msg: String
        },
        methods: {
            hide() {
                let alert = document.querySelector('#custom-alert');
                alert.style.opacity = 1;
                setTimeout(() => {
                    this.hideAnimation(alert);
                }, 3000);
            },
            hideAnimation(obj) {
                if (obj.style.opacity > 0) {
                    setTimeout(() => {
                        obj.style.opacity -= 0.05;
                        this.hideAnimation(obj);
                    }, 15);
                } else {
                    this.$emit('hided');
                }
            }
        },
        watch: {
            show(data) {
                if (data) {
                    this.hide();
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/share/alert.vue